import React, { useState, useContext } from "react";
import { Container, Row, Col, ProgressBar, Button } from "react-bootstrap";
import AppContext from "../../../context";
import "../../page/page.scss";
import { get_generic } from "../../../services/http_operations";

import { qualityCheck } from "./checkExperimentsUtilsFunction";
import { saveAs } from "file-saver";

export default function CheckExperimentHistoryPage() {
  const myLogs = useContext(AppContext).logs;

  //type of input to post resources

  const [now, setNow] = useState(0);

  const getExperiments = async () => {
    try {
      const user = localStorage.getItem("user-id");
      const res = await get_generic("experiments", {
        limit: -1,
        select: ["_id", "history"],
        filter: JSON.stringify({ owner: user }),
      });

      return res.docs;
    } catch (error) {
      console.error(error);
    }
  };

  // Incorrect values dict management functions

  const buildReport = (incorrectValues) => {
    const report = [];
    for (const [experimentId, incorrectValuesList] of Object.entries(
      incorrectValues
    )) {
      const incorrectSteps = [
        ...new Set(
          incorrectValuesList.errors?.map((error) => error.step) || []
        ),
      ];
      const incorrectFields = [
        ...new Set(
          incorrectValuesList.errors?.map((error) => error.fieldName) || []
        ),
      ];
      const incorrectnessMessages = [
        ...new Set(
          incorrectValuesList.errors?.map((error) => error.message) || []
        ),
      ];

      const warningSteps = [
        ...new Set(
          incorrectValuesList.warnings?.map((error) => error.step) || []
        ),
      ];
      const warningFields = [
        ...new Set(
          incorrectValuesList.warnings?.map((error) => error.fieldName) || []
        ),
      ];
      const warningMessages = [
        ...new Set(
          incorrectValuesList.warnings?.map((error) => error.message) || []
        ),
      ];

      report.push({
        experimentId: experimentId,
        incorrectSteps: incorrectSteps,
        incorrectFields: incorrectFields,
        incorrectnessMessages: incorrectnessMessages,
        warningSteps: warningSteps,
        warningFields: warningFields,
        warningMessages: warningMessages,
      });
    }

    return report;
  };

  // Function to format a single report entry
  function formatReportEntry(reportEntry) {
    let reportStr =
      "================================================================================================\n";
    reportStr +=
      "------------------------------------------------------------------------------------------------\n";
    reportStr += `Experiment: ${reportEntry.experimentId}\n`;
    reportStr +=
      "------------------------------------------------------------------------------------------------\n";
    reportStr += `Incorrect steps: ${reportEntry.incorrectSteps}\n`;
    reportStr += "Incorrect fields:\n";
    for (const field of reportEntry.incorrectFields) {
      reportStr += `${field}\n`;
    }
    reportStr +=
      "------------------------------------------------------------------------------------------------\n";
    reportStr += "Details:\n";
    for (const message of reportEntry.incorrectnessMessages) {
      reportStr += `${message}\n`;
    }
    reportStr +=
      "------------------------------------------------------------------------------------------------\n";
    reportStr += `Warning steps: ${reportEntry.warningSteps}\n`;
    reportStr += "Warning fields:\n";
    for (const field of reportEntry.warningFields) {
      reportStr += `${field}\n`;
    }
    reportStr +=
      "------------------------------------------------------------------------------------------------\n";
    reportStr += "Details:\n";
    for (const message of reportEntry.warningMessages) {
      reportStr += `${message}\n`;
    }
    reportStr +=
      "------------------------------------------------------------------------------------------------\n";

    reportStr +=
      "================================================================================================\n\n";
    return reportStr;
  }

  const checkHistory = async () => {
    setNow(0);

    myLogs.PushLog({
      type: "info",
      msg: "-------Begin Plausibility Check Operation-------\n",
    });

    myLogs.PushLog({
      type: "info",
      msg: "Retrieve Experiments\n",
    });

    const experiments = await getExperiments();

    myLogs.PushLog({
      type: "info",
      msg: experiments.length + " Experiments Found\n",
    });

    if (experiments.length === 0) {
      myLogs.PushLog({
        type: "info",
        msg: "No experiments found\n",
      });
      myLogs.PushLog({
        type: "info",
        msg: "-------Plausibility Check Operation Completed-------\n",
      });
      return;
    }

    myLogs.PushLog({
      type: "info",
      msg: "Processing Experiments\n",
    });

    const incorrectValues = {};
    const total = experiments.length;
    let current = 0;

    for (const experiment of experiments) {
      qualityCheck(experiment, incorrectValues);

      current += 1;
      setNow((current / total) * 100);
    }

    const report = buildReport(incorrectValues);

    if (report.length === 0) {
      myLogs.PushLog({
        type: "info",
        msg: "Processing Completed\n",
      });

      myLogs.PushLog({
        type: "info",
        msg: "All the values in Experiments are plausible\n",
      });

      myLogs.PushLog({
        type: "info",
        msg: "-------Plausibility Check Operation Completed-------\n",
      });

      return;
    }
    const formattedReport = report.map(formatReportEntry).join("\n");

    myLogs.PushLog({
      type: "info",
      msg: "Processing Completed\n",
    });

    const fileContent = new Blob([formattedReport], { type: "text/plain" });

    saveAs(fileContent, "PlausibilityCheckReport.txt");

    myLogs.PushLog({
      type: "info",
      msg: "Plausibility Check Report Downloaded\n",
    });

    myLogs.PushLog({
      type: "info",
      msg: "-------Plausibility Check Operation Completed-------\n",
    });
  };

  return (
    <div className="page">
      <header className="page-header">
        Plausibility Check on Experiment History
      </header>
      <main className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <Button onClick={checkHistory}>
                Start Plausibility Check on Experiments History
              </Button>
            </Col>
          </Row>
          <Row style={{ paddingTop: 10 + "px", paddingBottom: 10 + "px" }}>
            <Col>
              <ProgressBar
                now={now}
                label={`${now}%`}
                variant={now === 100 ? "success" : "info"}
              />
            </Col>
          </Row>
          <Row style={{ paddingTop: 10 + "px", paddingBottom: 10 + "px" }}>
            <Col>
              <b>Operation logs</b>
            </Col>
          </Row>
          <Row>
            <Col>
              <textarea
                id="logger"
                style={{ resize: "both", width: 30 + "vw", height: 30 + "vh" }}
                //cols="100"
                //rows="10"
                readOnly
                value={myLogs.logs
                  .map((l) => l.msg)
                  .reverse()
                  .join("-")}
              />
            </Col>
          </Row>
        </Container>
      </main>
    </div>
  );
}
